import * as React from "react";
const SvgPolygon = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("line", {
	x1: .353553,
	y1: .646447,
	x2: 12.3532,
	y2: 12.646,
	stroke: "#969FA8"
}));
export default SvgPolygon;
